
import { defineComponent, ref } from 'vue';
import { message } from 'ant-design-vue';
import { reactive } from 'vue';
import { end_order_used_record, query_order_used_record_staff_list } from '@/api/mjstore-model';
import { notification } from 'ant-design-vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import modalBox from '@/components/form-modal/modal-tools';

export default defineComponent({
  name: 'StaffWorkModel',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    obj: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const loading = ref(false);
    const columns: any = reactive([
      {
        title: '员工编码',
        dataIndex: 'staff__code',
        width: 150,
      },
      {
        title: '执行人',
        dataIndex: 'staff__name',
      },
      {
        title: '开始时间',
        dataIndex: 'start_datetime',
        slots: { customRender: 'datetime' },
        width: 185,
      },
      {
        title: '结束时间',
        dataIndex: 'end_datetime',
        slots: { customRender: 'datetime' },
        width: 185,
      },
      {
        title: '操作',
        dataIndex: 'action',
        width: 90,
        slots: { customRender: 'action' },
      },
    ]);
    const dataSource: any = reactive([]);

    const init = () => {
      dataSource.length = 0;
      if (props.obj && props.obj.id > 0) {
        query_order_used_record_staff_list({
          org_id: current_org.id,
          order_used_record_id: props.obj.id,
        }).then((res: any) => {
          for (const item of res.data) {
            dataSource.push(item);
          }
        });
      }
    };

    init();

    const handleCancel = () => {
      emit('cancel');
    };
    const handleEndOrder = (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '结束时间',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'datepicker',
              name: 'end_datetime',
              label: '结束时间',
              disabled: false,
              allowClear: true,
              defaultValue: '',
              showTime: true,
              placeholder: '请选择结束时间',
            },
          ],
          rules: {
            end_datetime: [{ required: true, message: '请选择结束时间' }],
          },
          model: {
            org_id: current_org?.id,
            order_used_record_id: props.obj.id,
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            end_order_used_record({
              ...payload,
              org_id: current_org?.id,
              order_used_record_id: props.obj.id,
              staff_id: record.staff_id,
            })
              .then(res => {
                notification.success({
                  message: '成功',
                  description: '更新成功',
                });
                Object.assign(record, res);
                init();
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    };

    return {
      // fullscreen
      message,
      // edit
      loading,
      columns,
      dataSource,
      handleEndOrder,
      handleCancel,
    };
  },
});
